import { useEffect, useRef } from "react";
import { useUserPreferencesStore } from "./userPreferencesStore";
import { useUserId } from "@/utils/utils";

export const useUserPreferences = () => {
  const userId = useUserId();
  const saveToSupabase = useUserPreferencesStore(
    (state) => state.saveToSupabase,
  );
  const smallNudge = useUserPreferencesStore((state) => state.smallNudge);
  const largeNudge = useUserPreferencesStore((state) => state.largeNudge);
  const githubAccessToken = useUserPreferencesStore(
    (state) => state.githubAccessToken,
  );
  const setSmallNudge = useUserPreferencesStore((state) => state.setSmallNudge);
  const setLargeNudge = useUserPreferencesStore((state) => state.setLargeNudge);
  const setGithubAccessToken = useUserPreferencesStore(
    (state) => state.setGithubAccessToken,
  );

  const timeoutRef = useRef<NodeJS.Timeout>();

  // Auto-save to Supabase when preferences change
  useEffect(() => {
    if (userId) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        saveToSupabase(userId);
      }, 1000); // Debounce for 1 second
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [userId, smallNudge, largeNudge, githubAccessToken, saveToSupabase]);

  return {
    smallNudge,
    largeNudge,
    githubAccessToken,
    setSmallNudge,
    setLargeNudge,
    setGithubAccessToken,
  };
};
